export const GET_DRIVER_ID_REQUEST = 'GET_DRIVER_ID_REQUEST' as const;
export const GET_DRIVER_ID_SUCCESS = 'GET_DRIVER_ID_SUCCESS' as const;

export const GET_DRIVER_DATA_REQUEST = 'GET_DRIVER_DATA_REQUEST' as const;
export const GET_DRIVER_AND_TRANSPORT_DATA_REQUEST = 'GET_DRIVER_AND_TRANSPORT_DATA_REQUEST' as const;
export const GET_DRIVER_DATA_SUCCESS = 'GET_DRIVER_DATA_SUCCESS' as const;

export const ADD_TO_BLACKLIST_REQUEST = 'ADD_TO_BLACKLIST_REQUEST' as const;
export const ADD_TO_BLACKLIST_SUCCESS = 'ADD_TO_BLACKLIST_SUCCESS' as const;
export const ADD_TO_BLACKLIST_ERROR = 'ADD_TO_BLACKLIST_ERROR' as const;

export const GET_DRIVER_ERROR = 'GET_DRIVER_ERROR' as const;
export const CLEAR_DRIVER_FIELD = 'CLEAR_DRIVER_FIELD' as const;
